import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    Grid,
    Divider,
    Button,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem
} from "@mui/material";
import { api } from "../../../../services/Main/Api";
import { useParams } from "react-router-dom";
import moment from "moment";
import {getCondoId} from "../../../../services/Main/AuthStorage";
import {Box} from "@mui/system";

const states = [
    "AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG",
    "PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"
];

export default function ContactDetail({ title }) {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    // modal de edição
    const [editOpen, setEditOpen] = useState(false);
    const [form, setForm] = useState({
        name: "",
        cpf_cnpj: "",
        email: "",
        phone: "",
        cep: "",
        street: "",
        number: "",
        district: "",
        city: "",
        state: "",
        complement: "",
    });

    useEffect(() => {
        api
            .get(`contacts/${id}/`)
            .then((res) => {
                setData(res.data);
                setForm({
                    name: res.data.name || "",
                    cpf_cnpj: res.data.cpf_cnpj || "",
                    email: res.data.email || "",
                    phone: res.data.phone || "",
                    cep: res.data.cep || "",
                    street: res.data.street || "",
                    number: res.data.number || "",
                    district: res.data.district || "",
                    city: res.data.city || "",
                    state: res.data.state || "",
                    complement: res.data.complement || "",
                });
            })
            .finally(() => setLoading(false));
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        const payload = {
            name: form.name,
            cpf_cnpj: form.cpf_cnpj,
            email: form.email,
            phone: form.phone,
            cep: form.cep,
            street: form.street,
            number: form.number,
            district: form.district,
            city: form.city,
            state: form.state,
            complement: form.complement,
            condo: getCondoId(),
        };

        api
            .put(`contacts/${id}/`, payload)
            .then((res) => {
                setData(res.data);   // atualiza dados exibidos na tela
                setEditOpen(false);  // fecha modal
            })
            .catch((err) => {
                console.error("Erro ao atualizar contato", err);
            });
    };

    if (loading) return <Typography>Carregando...</Typography>;
    if (!data) return <Typography>Contato não encontrado.</Typography>;

    return (
        <Stack spacing={3} sx={{ p: 3 }}>
            {/* HEADER */}
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box>

                </Box>

                <Button size={"small"} variant="contained" onClick={() => setEditOpen(true)}>
                    Editar
                </Button>
            </Stack>

            <Divider />

            {/* DADOS PRINCIPAIS */}
            <Card>
                <CardContent>
                    <Typography variant="h6">Informações Gerais</Typography>
                    <Grid container spacing={2} mt={1}>
                        <Grid item xs={12} sm={6}>
                            <strong>Nome:</strong> {data.name}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <strong>CPF/CNPJ:</strong> {data.cpf_cnpj}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <strong>Email:</strong> {data.email}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <strong>Telefone:</strong> {data.phone}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <strong>Criado em:</strong>{" "}
                            {moment(data.created_at).format("DD/MM/YYYY HH:mm")}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* ENDEREÇO */}
            <Card>
                <CardContent>
                    <Typography variant="h6">Endereço</Typography>
                    <Grid container spacing={2} mt={1}>
                        <Grid item xs={12} sm={3}>
                            <strong>CEP:</strong> {data.cep}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <strong>Rua:</strong> {data.street}
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <strong>Número:</strong> {data.number}
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <strong>Bairro:</strong> {data.district}
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <strong>Cidade:</strong> {data.city}
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <strong>UF:</strong> {data.state}
                        </Grid>
                        <Grid item xs={12}>
                            <strong>Complemento:</strong> {data.complement}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* MODAL DE EDIÇÃO */}
            <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullWidth maxWidth="md">
                <DialogTitle>Editar {title || data.type}</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} mt={1}>
                        {/* Dados principais */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Nome"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="CPF/CNPJ"
                                name="cpf_cnpj"
                                value={form.cpf_cnpj}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Telefone"
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                            />
                        </Grid>

                        {/* Endereço */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" sx={{ mt: 1 }}>
                                Endereço
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="CEP"
                                name="cep"
                                value={form.cep}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Rua"
                                name="street"
                                value={form.street}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Número"
                                name="number"
                                value={form.number}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Bairro"
                                name="district"
                                value={form.district}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Cidade"
                                name="city"
                                value={form.city}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                size="small"
                                select
                                label="UF"
                                name="state"
                                value={form.state}
                                onChange={handleChange}
                            >
                                {states.map((uf) => (
                                    <MenuItem key={uf} value={uf}>
                                        {uf}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Complemento"
                                name="complement"
                                value={form.complement}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "space-between", py: 2 }}>
                    <Button onClick={() => setEditOpen(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleSave}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </Stack>
    );
}
